module.exports = __webpack_public_path__ + "img/pages.db440f28.svg";